import { useNavigate, useParams } from "react-router-dom";
import { edit } from "../../asset";
import { PageHeader } from "../../components";
import SubHeadings from "../../components/SubHeadings";
import BankAndStatutoryDetails from "./BankAndStatutorydetails";
import SalaryOverView from "./SalaryOverview";
import { useEffect, useState } from "react";
import { Staff } from "../../types/staff";
import StaffApis from "../../api/staffApis";
import payrollManagement from "../../api/payrollManagementApis";
import { SalaryStructureResponse } from "../../types/payrollType";

export default function StaffOverview() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [staffData, setStaffData] = useState<Staff | null>(null);

  useEffect(() => {
    const fetchStaff = async () => {
      if (!id) return;

      const res = await StaffApis.getStaffById(Number(id));
      if (res?.data) {
        setStaffData(res.data);
      }
    };

    fetchStaff();
  }, [id]);

  const handleUpdateClick = () => {
    navigate(`/staff/staff-profile/${id}`, {
      state: { showReminder: true },
    });
  };

  const [salaryData, setSalaryData] = useState<SalaryStructureResponse | null>(
    null,
  );

  useEffect(() => {
    const fetchAll = async () => {
      if (!id) return;

      const staffRes = await StaffApis.getStaffById(Number(id));
      if (staffRes?.data) {
        setStaffData(staffRes.data);
      }

      const salaryRes = await payrollManagement.getSalaryStructure(Number(id));
      if (salaryRes?.status === 1) {
        setSalaryData(salaryRes.data);
      }
    };

    fetchAll();
  }, [id]);

  return (
    <div className="flex flex-col gap-3">
      <PageHeader
        showBack
        onBack={() => navigate("/payroll-management")}
        title={staffData?.employeeCode}
      />
      <div className="bg-white py-[18px] px-[22px] rounded-lg flex flex-col gap-4">
        <div className="flex justify-between items-center">
          <SubHeadings
            text="Personal Details"
            textColor="text-neutral-400"
            bgColor="bg-neutral-400"
          />
          <button
            onClick={handleUpdateClick}
            className="bg-warning-50 py-1 px-2 flex gap-2 items-center"
          >
            <img src={edit} alt="" />
            <span className=" text-warning-700 text-xs font-medium">Edit</span>
          </button>
        </div>
        <div className="flex  ">
          <div className="grid grid-cols-2 gap-10 w-full">
            <div className="grid gap-[10px]">
              <Info label="Staff Name" value={staffData?.fullName || "---"} />
              <Info label="Designation" value={staffData?.roleName || "---"} />
              <Info label="Saff ID" value={staffData?.employeeCode || "---"} />
              <Info
                label="Employee Type"
                value={staffData?.employeeType || "---"}
              />
              <Info label="Mobile Number" value={staffData?.mobile || "---"} />
              <Info label="Email Address" value={staffData?.email || "---"} />
              <Info
                label="Communication Address"
                value={staffData?.permanentAddress || "---"}
              />
            </div>
            <div className="grid gap-[10px]">
              <Info
                label="Date of Joining"
                value={staffData?.dateOfJoining || "---"}
              />
              <Info
                label="Birth Date"
                value={staffData?.dateOfBirth || "---"}
              />
              <Info
                label="Father’s Name"
                value={staffData?.fatherName || "---"}
              />
              <Info label="Gender" value={staffData?.gender || "---"} />
              <Info
                label="Aadhar Number"
                value={staffData?.aadhaarNumber || "---"}
              />
              <Info label="PAN" value={staffData?.panNumber || "----"} />
              <Info label="Staff UAN" value={staffData?.uanNumber || "---"} />
            </div>
          </div>

          <div className="flex justify-end shrink-0 pr-10">
            <img
              src={staffData?.profile_image_url}
              alt="Profile"
              className="w-28 h-28 rounded-full bg-background-200 object-cover"
            />
          </div>
        </div>
      </div>
      <div className="gap-2 flex">
        <BankAndStatutoryDetails data={staffData} salary={salaryData} />
        <SalaryOverView salary={salaryData} />
      </div>
    </div>
  );
}

export function Info({ label, value }: { label: string; value: string }) {
  return (
    <div className="grid grid-cols-2 gap-1 text-[13px]">
      <span className="text-neutral-300">{label}</span>
      <span className="text-neutral-500 font-medium">{value}</span>
    </div>
  );
}
